import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {EmptyFolderIcon} from 'shells/icon/svg/empty-folder-icon';
import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';

type Props = {
    groups: any[];
    templateGroupId: string;
    isDisabled?: boolean;
    onChange: (arg1: {id: string; name: string}) => void;
    styles?: any;
};

export function TemplateGroupPicker(props: Props) {
    const options = [...(props.groups || []), {id: 'null', name: 'Uncategorized'}];

    return (
        <div
            data-tip={
                props.isDisabled
                    ? 'Changing the group of a non-original template is not allowed -- select the original template to change groups'
                    : null
            }
        >
            <SelectPickerGeneric
                name='template_group'
                controlIcon={EmptyFolderIcon}
                isDisabled={props.isDisabled}
                value={options && options.find((group) => group.id === props.templateGroupId)}
                labelKey='name'
                valueKey='id'
                onChange={props.onChange}
                options={options}
                menuPlacement='auto'
                styles={props.styles}
            />
        </div>
    );
}
